import './less/fullScreenSlider.less';

const FullScreenSlider = selector => {
    let vanillaSlider = document.querySelector(selector);
    if (vanillaSlider) {
        let slider = $(selector);
    
        slider.owlCarousel({
            loop: false,
            merge: true,
            rewind: true,
            margin: 0,
            animateOut: 'fadeOut',
            autoplayTimeout: 10000,
            mouseDrag: false,
            autoplayHoverPause: false,
            autoplay: true,
            responsiveClass: true,
            navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            dots: true,
            items: 1,
            nav: false,
        });
    
        slider.on('changed.owl.carousel', function (event) {
            $('.fullScreenSlider__owl-names__name').removeClass('active');
            $('.name_' + event.item.index).addClass('active');
        });
    }
};


const fullScreenSlider = new FullScreenSlider('.fullScreenSlider');


export { fullScreenSlider };


// WEBPACK FOOTER //
// ./components/fullScreenSlider/fullScreenSlider.js